<template>
<div style="width: 100%" class="agency-page">
	<v-subheader>
		{{$t('agencies.agencies')}} > {{$t('agencies.agency')}} #{{ $route.params.agencyId }}
	</v-subheader>
	<v-container grid-list-lg>
		<v-card>
			<h3 class="caption-block">
				{{ $t('agencies.header') }}
			</h3>
			<v-card-title primary-title>
				<v-layout row wrap>

					<v-flex xs12 sm6 md6>
						<v-text-field
							:label="$t('agencies.person_firstname')"
							v-model="agency.person_firstname"
						/>
					</v-flex>

					<v-flex xs12 sm6 md6>
						<v-text-field
							:label="$t('agencies.person_lastname')"
							v-model="agency.person_lastname"
						/>
					</v-flex>

					<v-flex xs12 sm6 md4>
						<v-text-field
							:label="$t('agencies.social_security_number')"
							v-model="agency.social_security_number"
						/>
					</v-flex>

					<v-flex xs12 sm6 md4>
						<v-text-field
							:label="$t('agencies.spisova_znachka')"
							v-model="agency.spisova_znachka"
						/>
					</v-flex>

					<v-flex xs12 sm6 md4>
						<v-text-field
							:label="$t('agencies.mpsv')"
							v-model="agency.mpsv"
						/>
					</v-flex>


					<v-flex xs12 sm6 md6>
						<v-text-field
							:label="$t('agencies.name')"
							v-model="agency.name"
						/>
					</v-flex>

					<v-flex xs12 sm6 md6>
						<v-text-field
							:label="$t('agencies.ico')"
							v-model="agency.ico"
						/>
					</v-flex>

					<v-flex xs12 sm6 md6>
						<v-text-field
							:label="$t('agencies.dic')"
							v-model="agency.dic"
						/>
					</v-flex>
					<v-flex xs12 sm6 md6>
						<v-text-field
							:label="$t('agencies.company_number')"
							v-model="agency.company_number"
						/>
					</v-flex>
				</v-layout>
			</v-card-title>
		</v-card>
		<v-card class="contacts-block">
			<h3 class="caption-block">
				{{$t('workers.contacts')}}
			</h3>
			<v-card-title primary-title>
				<Contacts
					@add="addContact"
					@delete="deleteContact"
					:contact-types="$t('contacts_agency')"
					:contacts="agency.contacts"
				/>
			</v-card-title>
		</v-card>
		<v-card class="contacts-block">
			<h3 class="caption-block">
				{{$t('address.address')}}
			</h3>
			<v-card-title primary-title>
				<address-group
					:main-label="$t('address.agency_address')"
					:main-address="agency.agency_address && agency.agency_address[0]"
					:onlyMain="true"
					@update="updateAddressWithNotify"
					@createOne="createAddressOne"
					@delete="deleteAddressWithNotify"
				/>
			</v-card-title>
		</v-card>
		<v-layout row justify-center class="save-button">
			<v-tooltip top>
				<v-btn color="green lighten-1" class="white--text" slot="activator" @click="save">
					<v-icon>save</v-icon>
					<span style="padding-left: 5px">{{$t('common.save')}}</span>
				</v-btn>
				<span>
					{{$t('agencies.save_agency')}}
				</span>
			</v-tooltip>
		</v-layout>
	</v-container>
	<Loader v-if="isLoading" />
</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Loader from '../../components/Loader'
import Contacts from '../../components/Contacts'
import { notify } from '../../utils/notifications'
import AddressGroup from '../../components/address-group/AddressGroup'

export default {
	components: {
		Loader,
		Contacts,
		AddressGroup
	},
	created() {
		this.fetchOne()
	},
	computed: {
		...mapState({
			agency: ({ agencies }) => agencies.detail,
			isLoading: ({ agencies }) => agencies.isLoadingDetail
		})
	},
	methods: {
		...mapActions({
			fetchOne: 'agencies/fetchOne',
			saveAgency: 'agencies/updateAgency',
			createAddress: 'agencies/createAddress',
			updateAddress: 'agencies/updateAddress',
			deleteAddress: 'agencies/deleteAddress'
		}),
		...mapMutations({
			addContact: 'agencies/addContact',
			deleteContact: 'agencies/deleteContact'
		}),

		save() {
			this.saveAgency(this.agency).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.saved', {
						type: this.$t('agencies.agency')
					})
				})
			})
		},
		updateAddressWithNotify(data) {
			this.updateAddress(data).then(() => {
				this.$notify({
				...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('address.address')
					})
				})
			})
		},
		createAddressOne(data) {
			this.createAddress({
				...data,
				addressable_type: 'agency_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		deleteAddressWithNotify(data) {
			this.deleteAddress(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('common.deleted')
					})
				})
			})
		}
	}
}
</script>

<style scoped>
.center {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
.agency-page .caption-block {
	font-size: 18px;
	text-align: center;
	padding-top: 10px;
}
.agency-page .address-block,
.agency-page .contacts-block {
	margin-top: 10px;
}
</style>
